<div  class="productes-content">
  <div class="mdl-grid mdl-grid--no-spacing">
    <h5 class="mdl-layout-title mdl-cell--8-col">
      {{::'DEFAULT_PRODUCTE' | translate}}
    </h5>
    <div class="mdl-cell mdl-cell--4-col">
      <div class="itec-float-right">
	      <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored itec-float-right"
					 	ng-if="::$root.permisos.ESBORRARPRODUCTE.delete"
	          itec-dialog-confirm
	          itec-dialog-confirm-title="{{::'DEFAULT_TITOL_CONFIRMACIO_ESBORRAR' | translate}}"
	          itec-dialog-confirm-text-content="{{::'PRODUCTE_DELETE_CONTENT' | translate}}"
	          itec-dialog-confirm-text-ok="DIALOG_CONFIRM"
	          itec-dialog-confirm-text-cancel="DIALOG_CANCEL"
	          itec-dialog-confirm-function-ok="ctrl.deleteElem()">
	        <i class="material-icons">delete</i>
	      </button>
	      <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored itec-float-right"
								ng-if="::$root.permisos.ACTUALITZARPRODUCTE.edit"
								ng-click="ctrl.changeToForm()">
	        <i class="material-icons">edit</i>
	      </button>
      </div>
    </div>
  </div>



   <div class="mdl-cell--12-col">
      <md-card>
        <md-card-content>
   <div class="mdl-grid mdl-grid--no-spacing">
         <div class="mdl-cell mdl-cell--2-col">
               <span>{{::'DEFAULT_ID' | translate}}:</span>
          </div>
          <div class="mdl-cell mdl-cell--10-col">
               <span class="bold">{{::ctrl.producte.id}}</span>
          </div>
	        <div class="mdl-cell mdl-cell--2-col">
	              <span>{{::'DEFAULT_NOM' | translate}}:</span>
	         </div>
	         <div class="mdl-cell mdl-cell--4-col">
	              <span class="bold">{{::ctrl.producte.nom}}</span>
	         </div>
            <div class="mdl-cell mdl-cell--2-col">
                <span>{{::'DEFAULT_APLICACIO' | translate}}:</span>
            </div>
            <div class="mdl-cell mdl-cell--4-col">
                <span class="bold">{{::ctrl.producte.aplicacio.nom}}</span>
            </div>
            <div class="mdl-cell mdl-cell--2-col">
              <span>{{::'DEFAULT_CODI_client' | translate}}:</span>
            </div>
            <div class="mdl-cell mdl-cell--4-col">
              <span class="bold">{{::ctrl.producte.codiclient}}</span>
            </div>

            <div class="mdl-cell mdl-cell--2-col">
              <span>{{::'DEFAULT_TEDEMO' | translate}}:</span>
            </div>
	          <div  class="mdl-cell mdl-cell--4-col">
	              <span class="bold">{{::ctrl.producte.tedemo}}</span>
	          </div>
        </div>
        </md-card-content>
      </md-card>
    </div>
</div>
